import { ApplicationMethod } from 'src/components/CustomisationPage/feature/customisation.types';

export const nameOfSelectedMethod = (selectedMethod: number) => {
    switch (selectedMethod) {
        case ApplicationMethod.Both:
            return 'Both';
        case ApplicationMethod.Print:
            return 'Print';
        case ApplicationMethod.Embroidery:
            return 'Embroidery';
        case ApplicationMethod.None:
            return 'None';
        default:
            return 'None';
    }
};

export const nameOfNotAvailableMethod = (selectedMethod: number) => {
    switch (selectedMethod) {
        case ApplicationMethod.Both:
            return '';
        case ApplicationMethod.Print:
            return 'Embroidery';
        case ApplicationMethod.Embroidery:
            return 'Print';
        default:
            return 'None';
    }
};
